import React, { useState } from "react";
import Grid from "@mui/material/Grid2";
import MaterialBox from "../../../../../../components/MaterialBox";
import MaterialTypography from "../../../../../../components/MaterialTypography";
import MaterialInput from "../../../../../../components/MaterialInput";
import { FormControl, FormHelperText, Icon } from "@mui/material";
import MaterialLoadingButton from "../../../../../../components/MaterialLoadingButton";
import CheckIcon from "@mui/icons-material/Check";
import { useUserDetails } from "../../../../../../context/auth";
const BankDetails = ({
  employeeData,
  handleEmployeeDataChange,
  handleBankDetailsVerification,
  togglePage
}) => {
  const [ifscButtonStatus, setIfscButtonStatus] = useState("unverified");
  const [ifscDetails, setIfscDetails] = useState({
    bankName: "IOB",
    branchName: "Tirupur branch",
  });
      const {validation,validationMessages} = useUserDetails()
  
  const [panButtonStatus, setPanButtonStatus] = useState("unverified");
  const [aadharButtonStatus, setAadharButtonStatus] = useState("unverified");

  const handleIFSCVerification = async () => {
    setIfscButtonStatus("verifying");
    setTimeout(() => {
      getIfscData();
    }, 3000);
  };
  const getIfscData = () => {
    setIfscButtonStatus("verified");
    handleBankDetailsVerification(true, "Ifsc");
  };
  const handlePANVerification = async () => {
    setPanButtonStatus("verifying");
  };

  const handleAadharVerification = async () => {
    setAadharButtonStatus("verifying");
  };

  return (
    
    <MaterialBox>
   
      <MaterialTypography variant="h5">PF & ESI info</MaterialTypography>
      <Grid marginTop={1}  container spacing={2} alignItems="center">
 
  <Grid  item width={300} md={4} sm={6} xs={12}>
    <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
      <MaterialTypography component="label" variant="caption" fontWeight="bold">
        UAN Number
      </MaterialTypography>
    </MaterialBox>
    <MaterialInput
      type="text"
      placeholder="eg. 123456789012"
      name="uannumber"
      value={employeeData.uannumber}
      onChange={handleEmployeeDataChange}
      error={employeeData.uannumberStatus === "error"}
      success={employeeData.uannumberStatus === "success"}
      disabled={togglePage.view}
      sx={{ minWidth: "250px" }}  // Ensures consistent input width
    />
    {employeeData.uannumberStatus === "error" && (
      <FormControl error>
        <FormHelperText>UAN Number should be exactly 12 digits.</FormHelperText>
      </FormControl>
    )}
    {validationMessages.uannumber && (
      <label style={{ color: "red", fontSize: "12px" }}>
        {validationMessages.uannumber}
      </label>
    )}
  </Grid>

  {/* Member ID */}
  <Grid item width={300} md={4} sm={6} xs={12}>
    <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
      <MaterialTypography component="label" variant="caption" fontWeight="bold">
        Member ID
      </MaterialTypography>
    </MaterialBox>
    <MaterialInput
      type="text"
      name="memberid"
      value={employeeData.memberid}
      onChange={handleEmployeeDataChange}
      error={employeeData.memberidStatus === "error"}
      success={employeeData.memberidStatus === "success"}
      disabled={togglePage.view}
      sx={{ minWidth: "250px" }}
    />
    {employeeData.memberidStatus === "error" && (
      <FormControl error>
        <FormHelperText>
          Should accept only text and numbers (max 25 characters).
        </FormHelperText>
      </FormControl>
    )}
  </Grid>

  {/* ESIC Number */}
  <Grid item width={300} md={4} sm={6} xs={12}>
    <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
      <MaterialTypography component="label" variant="caption" fontWeight="bold">
        ESIC Number
      </MaterialTypography>
    </MaterialBox>
    <MaterialInput
      type="text"
      placeholder="eg. AHB00997665"
      name="esicnumber"
      value={employeeData.esicnumber}
      onChange={handleEmployeeDataChange}
      error={employeeData.esicnumberStatus === "error"}
      success={employeeData.esicnumberStatus === "success"}
      disabled={togglePage.view}
      sx={{ minWidth: "250px" }}
    />
    {employeeData.esicnumberStatus === "error" && (
      <FormControl error>
        <FormHelperText>
          Should accept only text and numbers (max 25 characters).
        </FormHelperText>
      </FormControl>
    )}
  </Grid>
</Grid>

    </MaterialBox>
  );
};

export default BankDetails;
